import { __assign } from "tslib";
/**
 * @param inputStr
 * @private
 */
var _parseColorAndOrClassnames = function (inputStr) {
    // prettier-ignore
    var colorWhitelist = [
        'primary', 'secondary', 'success', 'info', 'warning', 'danger', 'link',
    ];
    var customClassNames = [];
    var color = 'primary';
    var label = inputStr;
    // supported forms:
    //      color|label
    //      classname|label
    //      color,classname|label
    //      classname1,classname2|label
    //      color,classname1,classname2|label
    var parts = inputStr
        .split('|')
        .map(function (v) { return v.trim(); })
        .filter(function (v) { return !!v; });
    // intentionally strict, allow exactly one pipe
    if (parts.length === 2) {
        label = parts[1];
        parts[0]
            .split(',')
            .map(function (v) { return v.trim(); })
            .filter(function (v) { return !!v; })
            .forEach(function (v) {
            if (colorWhitelist.indexOf(v) !== -1) {
                color = v; // later wins
            }
            else {
                customClassNames.push(v);
            }
        });
    }
    return {
        label: label,
        color: color,
        customClassName: customClassNames.length ? customClassNames.join(' ') : null,
    };
};
/**
 * @param input
 */
export var parseMarkdownOption = function (input) {
    if (typeof input === 'string') {
        input = { label: input };
    }
    input = input;
    var out = {
        label: null,
        value: null,
        img: null,
        color: null,
        customClassName: null,
    };
    //
    if (input.theme) {
        // ugly BC hack input for parser fn
        out = __assign(__assign({}, out), _parseColorAndOrClassnames(input.theme + '|dummy'));
        out.label = input.label || input.utterance;
    }
    else {
        out = __assign(__assign({}, out), _parseColorAndOrClassnames(input.label || input.utterance));
    }
    // finalize output
    out.value = input.utterance || out.label;
    out.img = input.img || null;
    // update: target_node was removed from output
    // target_node has priority
    // if (input.target_node) {
    //     out.value = '@' + input.target_node;
    // }
    return out;
};
